module.exports = __webpack_public_path__ + "static/media/3D_SEQUENCER.46372037.svg";